import { qoursesApi } from '@/api/qourses.tsx'
import { useQuery } from '@tanstack/react-query'
import { PublicMediaImageEntity } from '../../../qourses-api-client'

export default function useGetMediaImagePublic(imageId: string): {
  mediaImage: PublicMediaImageEntity
  isLoading: boolean
  isError: boolean
  refetch: () => void
  isRefetching: boolean
} {
  const {
    data: mediaImage,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useQuery(
    getMediaImageQueryKey(imageId),
    async () => {
      return qoursesApi.mediaPublic.mediaPublicControllerGetMediaImageByIdV1(imageId)
    },
    {
      enabled: !!imageId,
    },
  )

  return {
    mediaImage: mediaImage,
    isLoading,
    isError,
    refetch,
    isRefetching,
  }
}

export const getMediaImageQueryKey = (imageId: string) => ['public', 'mediaImage', imageId]
